import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD5S4f8yspKp-TUbt86cvbkdMTEhAQAndQ",
  authDomain: "reelkarttest.firebaseapp.com",
  projectId: "reelkarttest",
  storageBucket: "reelkarttest.firebasestorage.app",
  messagingSenderId: "745147282782",
  appId: "1:745147282782:web:bf1f8bdfac3f934cb04bcf",
  measurementId: "G-RJNMGSWSNL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Use initializeFirestore to enable offline persistence and multi-tab support
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const storage = getStorage(app);
export const functions = getFunctions(app, "asia-south1");


// Initialize Analytics conditionally to avoid errors in some environments
let analyticsInstance = null;
try {
  analyticsInstance = getAnalytics(app);
} catch (e) {
  console.warn("Firebase Analytics failed to initialize (likely blocked or environment issue):", e);
}
export const analytics = analyticsInstance;
